import React, { useState,useRef } from 'react';
import { Editor } from 'primereact/editor';
import api from '../../Authenticaltion/api';
import { Calendar } from 'primereact/calendar';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { useLoading } from '../../LoadingContext';
import { useNavigate } from 'react-router-dom';

const ApplyReimbursement = () => {
    const [spentAmount, setSpentAmount] = useState('');
    const [reimbursementType, setReimbursementType] = useState('');
    const [spentDate, setSpentDate] = useState(null);
    const [reason, setReason] = useState('');
    const [file, setFile] = useState([]);
    const { updateLoading } = useLoading();
    const navigate = useNavigate();
    const inputRef = useRef(null);

    const customHeader = (
        <span className="ql-formats">
            <button className="ql-bold"></button>
            <button className="ql-italic"></button>
            <button className="ql-underline"></button>
            <button className="ql-list" value="ordered"></button>
            <button className="ql-list" value="bullet"></button>
        </span>
    );

    const handleFileChange = (e) => {
    const picked = Array.from(e.target.files || []);

    // size check: 5 MB per file
    const tooBig = picked.find(f => f.size > 5 * 1024 * 1024);
    if (tooBig) {
      Swal.fire({
        icon: "warning",
        text: `File "${tooBig.name}" is larger than 5 MB.`,
        timer: 2000,
        showConfirmButton: false
      });
      e.target.value = "";     // clear the input
      setFile([]);            // clear state to an empty ARRAY
      return;
    }

    // append to existing files
    setFile(prev => [...prev, ...picked]);  // <-- prev is an array now
    e.target.value = ""; // optional: allow picking same file again
  };
console.log("the files are",file);

const removeAt = (idx) =>
    setFile(prev => prev.filter((_, i) => i !== idx));

   const handleSubmit = async (e) => {
    e.preventDefault();
    updateLoading(true);
    const amount = spentAmount.trim();

    if (
        !amount ||
        parseFloat(amount) <= 0 ||
        !reimbursementType ||
        !spentDate ||
        !reason.trim() ||
        !file.length // <-- check multiple files
    ) {
        Swal.fire({
            icon: 'warning',
            text: 'Please fill all mandatory fields',
            timer: 2000,
            showConfirmButton: false
        });
        updateLoading(false);
        return;
    }

    if (amount <= 50000) {
        let data = new FormData();
        data.append('amount', amount);
        data.append('typeName', reimbursementType);
        data.append('reason', reason);
        data.append(
            'date_spent',
            new Date(spentDate.getTime() - spentDate.getTimezoneOffset() * 60000)
                .toISOString()
                .split('T')[0]
        );

        // ✅ Loop through multiple files
        if (file && file.length > 0) {
            file.forEach((file) => {
                data.append('files', file); // name should match multer.array('files')
            });
        }
          console.log(data);
        try {
            const response = await api.post('/ApplyReinversement', data);
            if (response.status === 201) {
                Swal.fire({
                    icon: 'success',
                    text: 'Reimbursement applied successfully!',
                    timer: 2000,
                    showConfirmButton: false
                }).then(() => {
                    setSpentAmount('');
                    setReimbursementType('');
                    setSpentDate(null);
                    setReason('');
                    setFile([]); // reset multiple files
                    navigate('/Reimbursement');
                });
            }
        } catch (error) {
            toast.error('Failed to submit the reimbursement application. Please try again.');
            console.error(error);
        } finally {
            updateLoading(false);
        }
    } else {
        Swal.fire({
            icon: 'warning',
            text: 'Amount should be less than or equal to 50000',
            timer: 2000,
            showConfirmButton: false
        });
        updateLoading(false);
    }
};

    const handleAmountInput = (e) => {
        let value = e.target.value;
        // Limit input to maximum 6 digits
        if (value.length > 6) {
            value = value.slice(0, 6);
        }
        // Ensure only digits and optional decimal point
        value = value.replace(/[^0-9.]/g, '');
        // Ensure only one decimal point
        const parts = value.split('.');
        if (parts.length > 2) {
            value = `${parts[0]}.${parts[1]}`;
        }
        setSpentAmount(value);
    };

    return (
        <div class=" shadow p-3 bg-white rounded">
            <div class="h5 pb-2 mt-2 mb-2 border-bottom text-primary">
                Apply Reimbursement
            </div>
            <form className="row mt-4" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col text-right">
                        <span className="text-primary">Amount you want to reimburse: {spentAmount}</span>
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="mb-3">
                        <label htmlFor="leaveType" className="form-label">
                            Reimbursement Type <span className="text-danger fw-bold">*</span>
                        </label>
                        <select
                            className="form-select"
                            id="ReimbursementType"
                            name="ReimbursementType"
                            required
                            onChange={(e) => setReimbursementType(e.target.value)}
                        >
                            <option selected disabled>Select Reimbursement Type</option>
                            <option value="Travel">Travel</option>
                            <option value="Food and Hotel">Food and Hotel</option>
                            <option value="Mobile Recharge and Internet">Mobile Recharge and Internet</option>
                            <option value="Server">Server</option>
                            <option value="Domain">Domain</option>
                            <option value="Others">Others</option>
                        </select>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="SpentOn" className="form-label">
                            Spent on <span className="text-danger fw-bold">*</span>
                        </label>
                        <Calendar
                            value={spentDate}
                            onChange={(e) => setSpentDate(e.value)}
                            showIcon
                            style={{ height: '35px', width: '100%' }}
                            dateFormat="dd/mm/yy"
                            maxDate={new Date()}
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="SpentAmount" className="form-label">
                            Enter Amount <span className="text-danger fw-bold">*</span>
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            value={spentAmount}
                            onInput={handleAmountInput}
                            min={0}
                            max={50000}
                        />
                    </div>
                    <div className="mb-3">
      <label htmlFor="BillDocument" className="form-label">
        Upload Bill <span className="text-danger fw-bold">*</span>
      </label>

      {/* hidden file input */}
      <input
        ref={inputRef}
        id="BillDocument"
        type="file"
        accept=".pdf, image/*"
        multiple
        className="form-control"
        onChange={handleFileChange}
        style={{ display: "none" }}
        
      />

      {/* + button to add more */}
      <button style={{marginLeft:'10px'}}
        type="button"
        className="btn btn-outline-primary"
        onClick={() => inputRef.current?.click()}
      >
        +
      </button>

      <small className="form-text" style={{ color: "red", display: "block", marginTop: 8 }}>
        Acceptable file types: PDF, JPEG, PNG. Maximum size: 5 MB.
      </small>

      {/* previews / file list */}
      <div className="mt-3 d-flex flex-wrap gap-2">
        {file.map((file, i) =>
          file.type.startsWith("image/") ? (
            <div key={i} className="position-relative">
              <img
                src={URL.createObjectURL(file)}
                alt={file.name}
                style={{ width: 100, height: 100, objectFit: "cover", borderRadius: 8 }}
                onLoad={e => URL.revokeObjectURL(e.currentTarget.src)}
              />
              <button
                type="button"
                className="btn btn-sm btn-danger"
                style={{ position: "absolute", top: 2, right: 2 }}
                onClick={() => removeAt(i)}
              >
                ×
              </button>
            </div>
          ) : (
            <div key={i} className="border p-2 rounded bg-light d-flex align-items-center">
              📄 {file.name}
              <button
                type="button"
                className="btn btn-sm btn-danger ms-2"
                onClick={() => removeAt(i)}
              >
                Remove
              </button>
            </div>
          )
        )}
      </div>
    </div>
                </div>
                <div className="col-sm-6">
                    <label htmlFor="SpentDescription" className="form-label">
                        Description <span className="text-danger fw-bold">*</span>
                    </label>
                    <Editor
                        id="SpentMessage"
                        headerTemplate={customHeader}
                        style={{ height: '240px' }}
                        required
                        onTextChange={(e) => setReason(e.htmlValue)}
                    />
                </div>
                <div className="mb-3 text-center">
                    <button type="submit" className="btn" style={{ backgroundColor: '#6366F1', color: 'white', borderRadius: '20px' }}>Submit</button>
                </div>
            </form>
        </div>
    );
};

export default ApplyReimbursement;
